function formatPrice(number) {
    let prefix = 'CHF&nbsp;';
    let suffix = '.–';

    if (number.toString().includes('.')) {
        number = number.toFixed(2);
        suffix = '';
    }

    return prefix + addThousandMarks(number) + suffix;
}

function addThousandMarks(number) {
    let parts = number.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '\'');
    return parts.join('.');
}

export {formatPrice}
